import client from "./client";

export const fetchInstallerLink = async (): Promise<string> => {
  return await client
    .get("/resources/installer")
    .then(res => res.data.response.installerLink);
};

export const fetchCharismaWorkbookLink = async (): Promise<string> => {
  return await client
    .get("/resources/workbook")
    .then(res => res.data.response.workbookLink);
};
